import classNames from 'classnames';
import { forwardRef } from 'react';

export interface TableRowProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLTableRowElement>, HTMLTableRowElement> {
  className?: string;
  selected?: boolean;
  hover?: boolean;
  verticalAlign?: 'inherit' | 'top' | 'middle' | 'bottom';
}

export const TableRow = forwardRef<HTMLTableRowElement, React.PropsWithChildren<TableRowProps>>(
  ({ className, children, selected = false, hover, verticalAlign = 'top', ...otherProps }, ref) => {
    return (
      <tr
        {...otherProps}
        ref={ref}
        className={classNames(
          'relative bg-surface-base border-border',
          '[&>td:first-child]:relative',
          `[&>td:first-child]:before:content-['_']`,
          '[&>td:first-child]:before:block [&>td:first-child]:before:absolute [&>td:first-child]:before:left-0 [&>td:first-child]:before:top-0 [&>td:first-child]:before:bottom-0 [&>td:first-child]:before:max-h-[3rem] [&>td:first-child]:before:h-[calc(100%-8px)] [&>td:first-child]:before:w-1 [&>td:first-child]:before:my-auto [&>td:first-child]:before:rounded-r-lg [&>td:first-child]:before:pointer-events-none',
          '[&>td:first-child]:before:transition-color [&>td:first-child]:before:duration-100 [&>td:first-child]:before:ease-in-out',
          verticalAlign === 'inherit' && '[vertical-align:inherit]',
          verticalAlign === 'top' && 'align-top',
          verticalAlign === 'middle' && 'align-middle',
          verticalAlign === 'bottom' && 'align-bottom',
          selected
            ? '[&>td:first-child]:before:bg-cyan-600 [&>td:first-child]:before:dark:bg-cyan-500'
            : '[&>td:first-child]:before:dark:bg-transparent [&>td:first-child]:before:bg-transparent',
          hover
            ? 'cursor-pointer transition ease-in-out hover:bg-surface-hover dark:hover:bg-surface-hover'
            : undefined,
          className,
        )}
      >
        {children}
      </tr>
    );
  },
);

export default TableRow;
